import React from 'react';
import PropTypes from 'prop-types';
import { Doughnut } from 'react-chartjs-2';
import { withTranslation } from 'react-i18next';
import colors from '../../../shared/utils/colors';

const ReceivablesByAccountChart = (props) => {
  const { dataLabels, numbersChart, options } = props;

  const data = {
    labels: dataLabels,
    datasets: [
      {
        data: numbersChart,
        backgroundColor: colors,
        hoverBackgroundColor: ['#9c2dd2', '#D4a3ee'],
        borderColor: 'rgba(255,255,255,0.54)',
      },
    ],
  };

  const legendOptions = {
    display: false,
  };

  return (
    <Doughnut
      height={300}
      data={data}
      legend={legendOptions}
      options={options}
    />
  );
};

ReceivablesByAccountChart.propTypes = {
  dataLabels: PropTypes.arrayOf(PropTypes.shape),
  numbersChart: PropTypes.arrayOf(PropTypes.shape).isRequired,
  options: PropTypes.shape(PropTypes.shape),
};

ReceivablesByAccountChart.defaultProps = {
  dataLabels: [],
  options: {},
};

export default withTranslation('common')(ReceivablesByAccountChart);
